import type { VoidFunctionComponent } from 'react';

import styles from './TeamsBanner.module.less';

/**
 * TeamsBanner displays a static info banner under the teams dropdown informing the user
 * that all selected teams will be applied to each project in the release group.
 */
const TeamsBanner: VoidFunctionComponent = () => {
  return (
    <div className={styles.banner}>
      NOTE: All selected teams will be assigned the projects you add to this release group.
    </div>
  );
};

export default TeamsBanner;
